<template>
  <div class="deviceOverview">
    <div class="deviceOverviewLeft">
      <div class="deviceDiagram">
        <!-- 设备状态 -->
        <div
          class="deviceStatus"
          v-loading="
            $store.state.user.dealerVcode == '08'
              ? deviceDataloggerStatus.isLoading
              : deviceStatus.isLoading
          "
          element-loading-spinner="el-icon-loading"
        >
          <div
            class="eb-chart-box eb-shadowL3 emptyTextRelative"
            style="width: 100%"
          >
            <div class="eb-chart-header">
              <span class="eb-chart-topleft">
                <span>{{ $t("statistic.deviceStatus") }}</span>
              </span>
            </div>
            <div
              v-show="!emptyTextDeviceStatus"
              class="eb-chart-panel deviceStatusContent"
            >
              <!-- :typeRing="'B'" -->
              <echart-pie
                class="deviceStatusLeft"
                :name="deviceName"
                :data="
                  $store.state.user.dealerVcode == '08'
                    ? deviceDataloggerStatus.chartData
                    : deviceStatus.chartData
                "
                :total="
                  $store.state.user.dealerVcode == '08'
                    ? deviceDataloggerStatus.total
                    : deviceStatus.total
                "
              ></echart-pie>
              <div
                v-if="$store.state.user.dealerVcode == '08'"
                class="deviceStatusRight"
              >
                <template>
                  <div
                    v-for="(item, key) in deviceDataloggerStatus.dic"
                    :key="key"
                  >
                    <span class="item-name" :key="key + 'name'">
                      <i
                        class="status-icon"
                        :style="{ 'background-color': item.color }"
                      ></i>
                      {{ item.name }}
                    </span>
                    <span class="item-value" :key="key + 'value'">{{
                      item.value
                    }}</span>
                  </div>
                </template>
              </div>
              <div v-else class="deviceStatusRight">
                <template>
                  <div v-for="(item, key) in deviceStatus.dic" :key="key">
                    <span class="item-name" :key="key + 'name'">
                      <i
                        class="status-icon"
                        :style="{ 'background-color': item.color }"
                      ></i>
                      {{ item.name }}
                    </span>
                    <span class="item-value" :key="key + 'value'">{{
                      item.value
                    }}</span>
                  </div>
                </template>
              </div>
            </div>
            <!-- 暂无数据 -->
            <div
              class="emptyTextAbsolute"
              v-show="emptyTextDeviceStatus"
              slot="empty"
            >
              <div style="line-height: 32px; color: #606266">
                {{ $t("account.nodata") }}
              </div>
            </div>
          </div>
        </div>
        <!-- 设备分布区域 -->
        <div
          class="deviceDistribution emptyTextRelative"
          v-loading="deviceDistributionStatus.isLoading"
          element-loading-spinner="el-icon-loading"
        >
          <div class="eb-chart-header">
            <span class="eb-chart-topleft">
              <span>{{ $t("statistic.regionPercent") }}</span>
            </span>
          </div>
          <div
            class="eb-chart-panel deviceDistributionContent"
            v-show="!emptyTextDistribution"
          >
            <echart-pie
              class="deviceDistributionLeft"
              :data="deviceDistributionStatus.chartData"
              :total="deviceDistributionStatus.total"
            ></echart-pie>
            <div class="deviceDistributionRight">
              <template>
                <div
                  v-for="(item, key) in deviceDistributionStatus.chartData"
                  :key="key"
                >
                  <span class="item-name" :key="key + 'name'">
                    <i
                      class="status-icon"
                      :style="{ 'background-color': item.itemStyle.color }"
                    ></i>
                    {{ item.name }}
                  </span>
                  <span class="item-value" :key="key + 'value'">{{
                    item.value
                  }}</span>
                </div>
              </template>
            </div>
          </div>
          <!-- 暂无数据 -->
          <div
            class="emptyTextAbsolute"
            v-show="emptyTextAlarmStatus"
            slot="empty"
          >
            <div style="line-height: 32px; color: #606266">
              {{ $t("account.nodata") }}
            </div>
          </div>
        </div>
        <!-- 告警事件统计 -->
        <div
          v-if="this.$store.state.user.role == 2"
          class="alarmStatus1"
          v-loading="alarmStatus.isLoading"
          element-loading-spinner="el-icon-loading"
        >
          <div
            class="eb-chart-box eb-shadowL3 emptyTextRelative"
            style="width: 100%"
          >
            <div class="eb-chart-header">
              <span class="eb-chart-topleft">
                <span>{{ $t("alarm.alarmStatus") }}</span>
              </span>
            </div>
            <div
              v-show="!emptyTextAlarmStatus"
              class="eb-chart-panel alarmStatusContent"
            >
              <echart-pie
                class="alarmStatusLeft"
                :data="alarmStatus.chartData"
                :total="alarmStatus.total"
              ></echart-pie>
              <div class="alarmStatusRight">
                <template>
                  <div v-for="(item, key) in alarmStatus.dic" :key="key">
                    <span class="item-name" :key="key + 'name'">
                      <i
                        class="status-icon"
                        :style="{ 'background-color': item.color }"
                      ></i>
                      {{ item.name }}
                    </span>
                    <span class="item-value" :key="key + 'value'">{{
                      item.value
                    }}</span>
                  </div>
                </template>
              </div>
            </div>
            <!-- 暂无数据 -->
            <div
              class="emptyTextAbsolute"
              v-show="emptyTextAlarmStatus"
              slot="empty"
            >
              <div style="line-height: 32px; color: #606266">
                {{ $t("account.nodata") }}
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- 用户活跃率 -->
      <div
        class="userActivity emptyTextRelative"
        v-if="this.$store.state.user.role == 1"
        v-loading="accountStatus.isLoading"
        element-loading-spinner="el-icon-loading"
      >
        <div class="totalnum">
          <div class="title">
            {{ $t("statistic.userActivity") }}
          </div>
          <div>
            <span class="Total_user">{{ $t("menu.Total_user") }}</span>
            <span class="totalUsr">{{ totalUsr }}</span>
          </div>
        </div>
        <div
          class="chart-account"
          v-show="!emptyTextUserStatus"
          style="height: 300px"
        >
          <echart-three-ring
            :data="accountStatus.chartData"
          ></echart-three-ring>
        </div>
        <div
          class="emptyTextAbsolute"
          v-show="emptyTextUserStatus"
          slot="empty"
        >
          <div style="line-height: 32px; color: #606266">
            {{ $t("account.nodata") }}
          </div>
        </div>
      </div>
      <div
        class="userActivity1 emptyTextRelative"
        v-if="this.$store.state.user.role == 2"
        v-loading="accountStatus.isLoading"
        element-loading-spinner="el-icon-loading"
      >
        <div class="totalnum">
          <div class="title">
            {{ $t("statistic.userActivity") }}
          </div>
          <div>
            <span class="Total_user">{{ $t("menu.Total_user") }}</span>
            <span class="totalUsr">{{ totalUsr }}</span>
          </div>
        </div>
        <div
          class="chart-account"
          v-show="!emptyTextUserStatus"
          style="height: 300px"
        >
          <echart-three-ring
            :data="accountStatus.chartData"
          ></echart-three-ring>
        </div>
        <!-- 暂无数据 -->
        <div
          class="emptyTextAbsolute"
          v-show="emptyTextUserStatus"
          slot="empty"
        >
          <div style="line-height: 32px; color: #606266">
            {{ $t("account.nodata") }}
          </div>
        </div>
      </div>
    </div>
    <div class="deviceOverviewRight" v-if="this.$store.state.user.role == 1">
      <!-- 告警事件统计 -->
      <div
        class="alarmStatus"
        v-loading="alarmStatus.isLoading"
        element-loading-spinner="el-icon-loading"
      >
        <div
          class="eb-chart-box eb-shadowL3 emptyTextRelative"
          style="height: 283px"
        >
          <div class="eb-chart-header" style="display: flex;justify-content: space-between;align-items: center;">
            <span class="eb-chart-topleft">
              <span>{{ $t("alarm.alarmStatus") }}</span>
            </span>
            <span class="alarm-update-time">{{ $t("statistic.dataUpdateTime") }}: {{ alarmTIME }}</span>
          </div>
          <div
            v-show="!emptyTextAlarmStatus"
            class="eb-chart-panel alarmStatusContent"
          >
            <!-- :typeRing="'B'" -->
            <echart-pie
              class="alarmStatusLeft"
              :name="alarmName"
              :data="alarmStatus.chartData"
              :total="alarmStatus.total"
            ></echart-pie>
            <div class="alarmStatusRight">
              <template>
                <div v-for="(item, key) in alarmStatus.dic" :key="key">
                  <span class="item-name" :key="key + 'name'">
                    <i
                      class="status-icon"
                      :style="{ 'background-color': item.color }"
                    ></i>
                    {{ item.name }}
                  </span>
                  <span class="item-value" :key="key + 'value'">{{
                    item.value
                  }}</span>
                </div>
              </template>
            </div>
          </div>
          <!-- 暂无数据 -->
          <div
            class="emptyTextAbsolute"
            v-show="emptyTextAlarmStatus"
            slot="empty"
          >
            <div style="line-height: 32px; color: #606266">
              {{ $t("account.nodata") }}
            </div>
          </div>
        </div>
      </div>
      <!-- 告警 -->
      <div
        class="warningStatus emptyTextRelative"
        v-if="this.$store.state.user.role == 1"
        v-loading="chartData.isLoading"
        element-loading-spinner="el-icon-loading"
      >
        <div class="eb-chart-header">
          <span class="eb-chart-topleft">
            <span>{{ $t("alarm.warningTitle") }}</span>
          </span>
        </div>
        <div class="eb-chart-panel" v-show="!emptyTextAlarmWarningStatus">
          <echart-line
            class="line"
            :category="chartData.category"
            :data="chartData.data"
            :unitX="chartData.unitX"
          ></echart-line>
        </div>
        <!-- 暂无数据 -->
        <div
          class="emptyTextAbsolute"
          v-show="emptyTextAlarmWarningStatus"
          slot="empty"
        >
          <div style="line-height: 32px; color: #606266">
            {{ $t("account.nodata") }}
          </div>
        </div>
      </div>
      <!-- 故障 -->
      <div
        class="faultStatus emptyTextRelative"
        v-if="this.$store.state.user.role == 1"
        v-loading="chartData1.isLoading"
        element-loading-spinner="el-icon-loading"
      >
        <div class="eb-chart-header">
          <span class="eb-chart-topleft">
            <span>{{ $t("alarm.faultTitle") }}</span>
          </span>
        </div>
        <div class="eb-chart-panel" v-show="!emptyTextAlarmFaultStatus">
          <echart-line2
            class="line"
            :category="chartData1.category"
            :data="chartData1.data"
            :unitX="chartData1.unitX"
          ></echart-line2>
        </div>
        <!-- 暂无数据 -->
        <div
          class="emptyTextAbsolute"
          v-show="emptyTextAlarmFaultStatus"
          slot="empty"
        >
          <div style="line-height: 32px; color: #606266">
            {{ $t("account.nodata") }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
// [3-1]饼图（环形）
import { i18n } from "@/i18n";
import { mapGetters } from "vuex";
import * as echarts from "echarts";
// [1-1]面积图（重叠）
import echartLine from "../../../components/echartsNew/line1.vue";
import echartLine2 from "../../../components/echartsNew/line2.vue";
import echartPie from "../../../components/echartsNew/pie3.vue";
import echartMap from "../../../components/echartsNew/map.vue";
import echartBar4 from "../../../components/echartsNew/barNew1.vue";
import echartThreeRing from "../../../components/echartsNew/threeRing1.vue";
export default {
  components: {
    echartPie,
    // echartMap,
    // echartBar4,
    echartLine,
    echartLine2,
    echartThreeRing,
  },
  data() {
    return {
      // 设备状态数据
      deviceStatus: {
        dic: {
          normalCount: {
            name: this.$t("statistic.normal"),
            color: "#61DDAA",
            value: 0,
          },
          offCount: {
            name: this.$t("statistic.offline"),
            color: "#94A3B3",
            value: 0,
          },
          warningCount: {
            name: this.$t("statistic.warning"),
            color: "#F6BD16",
            value: 0,
          },
          faultCount: {
            name: this.$t("statistic.fault"),
            color: "#DD6843",
            value: 0,
          },
          standby: {
            name: this.$t("statistic.standby"),
            color: "#54A0FF",
            value: 0,
          },
        },
        chartData: [],
        total: {
          name: this.$t("statistic.allDevice"),
          value: 0,
        },
        isLoading: false,
      },
      // 采集器状态数据
      deviceDataloggerStatus: {
        dic: {
          normalCount: {
            name: this.$t("statistic.normal"),
            color: "#61DDAA",
            value: 0,
          },
          offCount: {
            name: this.$t("statistic.offline"),
            color: "#94A3B3",
            value: 0,
          },
          warningCount: {
            name: this.$t("statistic.warning"),
            color: "#F6BD16",
            value: 0,
          },
        },
        chartData: [],
        total: {
          name: this.$t("statistic.allDevice"),
          value: 0,
        },
        isLoading: false,
      },
      //设备分布数据
      mapData: [],
      deviceDistributionStatus: {
        dic: [
          { color: "rgb(80, 165, 250)" },
          { color: "rgb(95, 199, 242)" },
          { color: "rgb(255, 124, 124)" },
          { color: "rgb(255, 211, 124)" },
          { color: "rgb(38, 211, 211)" },
          { color: "rgb(76, 216, 147)" },
          { color: "rgb(255, 168, 124)" },
          { color: "rgb(124, 124, 255)" },
          { color: "rgb(255, 165, 0)" },
          { color: "rgb(50, 205, 50)" },
        ],
        chartData: [],
        total: {
          name: this.$t("statistic.regiontotal"),
          value: 0,
        },
        isLoading: false,
      },
      // 用户活跃数据
      accountStatus: {
        isLoading: false,
        chartData: [
          {
            detail: [],
            field: "totolView",
            activeColor: "#4d9bf9",
            role: "",
            summary: {
              name: this.$t("statistic.allAccount"),
              value: 0,
            },
          },
          {
            detail: [],
            field: "ownerView",
            activeColor: "#46ba59",
            role: "0",
            summary: {
              name: this.$t("statistic.generalAccount"),
              value: 0,
            },
          },
          {
            detail: [],
            field: "adminView",
            activeColor: "#ffd326",
            role: "2",
            summary: {
              name: this.$t("statistic.adminAccount"),
              value: 0,
            },
          },
        ],
      },
      // 设备告警事件总数
      alarmName: "alarmName",
      alarmTIME:'',
      // 设备状态
      deviceName: "deviceName",
      alarmStatus: {
        dic: {
          Handle: {
            name: this.$t("alarm.processed"),
            color: "#5195DA",
            value: 0,
          },
          Untreated: {
            name: this.$t("alarm.untreated"),
            color: "#FF4F72",
            value: 0,
          },
        },
        chartData: [],
        total: {
          name: this.$t("alarm.allAlarm"),
          value: 0,
        },
        isLoading: false,
      },
      totalUsr: "",
      // 折线面积图
      //告警数
      chartData: {
        // 数据模块
        category: [],
        data: [],
        unitX: "",
        isLoading: false,
      },
      //故障数
      chartData1: {
        // 数据模块
        category: [],
        data: [],
        unitX: "",
        isLoading: false,
      },
      arr: [],
      arr2: [],
      arr3: [],
      arr4: [],
      arr5: [],
      arr6: [],
      // [附2]柱状图（极坐标）
      legendsArr: [
        { label: "参数1" },
        { label: "参数2" },
        { label: "参数3" },
        { label: "参数4" },
      ],
      chartData5: {
        // 数据模块
        category: [],
        data: [],
        unitX: "",
      },
      emptyTextDeviceStatus: false, //设备状态
      emptyTextDistribution: false, //设备分布
      emptyTextUserStatus: false, //用户活跃
      emptyTextAlarmStatus: false, //设备告警事件
      emptyTextAlarmWarningStatus: false, //设备告警
      emptyTextAlarmFaultStatus: false, //设备故障
    };
  },
  computed: {
    // 设备状态百分比
    devicePercentData() {
      let result = {},
        total =
          this.$store.state.user.dealerVcode == "08"
            ? this.deviceDataloggerStatus.total.value
            : this.deviceStatus.total.value;
      if (this.$store.state.user.dealerVcode == "08") {
        for (let key in this.deviceDataloggerStatus.dic) {
          result[key] =
            total != 0
              ? (
                  (this.deviceDataloggerStatus.dic[key].value * 100) /
                  total
                ).toFixed(2) + "%"
              : "0%";
        }
      } else {
        for (let key in this.deviceStatus.dic) {
          result[key] =
            total != 0
              ? ((this.deviceStatus.dic[key].value * 100) / total).toFixed(2) +
                "%"
              : "0%";
        }
      }
      return result;
    },
    // 告警状态百分比
    alarmPercentData() {
      let result = {},
        total = this.alarmStatus.total.value;
      for (let key in this.alarmStatus.dic) {
        result[key] =
          total != 0
            ? ((this.alarmStatus.dic[key].value * 100) / total).toFixed(2) + "%"
            : "0%";
      }
      return result;
    },
  },
  created() {
    this.queryDeviceStatus();
    this.queryAlarmStatus();
    this.getQueryDeviceRegionViewEs();
    this.getUseractivity();
    if (this.$store.state.user.role == 1) {
      this.PlantsWarningAndFaultCount();
      this.PlantsWarningAndFaultCount1();
    }

    this.getQueryDataIs();
  },
  mounted() {},
  watch: {
    // 响应更新电站列表事件
    "$store.state.user.dealerVcode"(val) {
      if (val) {
        this.queryDeviceStatus();
      }
    },
  },
  methods: {
    // 告警折线图
    PlantsWarningAndFaultCount() {
      this.chartData.isLoading = true;
      this.arr = [];
      this.arr2 = [];
      this.arr3 = [];
      let param = {
        lev: 0,
        flag: 0,
      };
      this.$request
        .getMicroserDess("/alm/api/auth/web/warningTrend", param)
        .then((res) => {
          if (res.code === 0 && Array.isArray(res.data)) {
            res.data.forEach((item) => {
              let asd = {};
              asd.value = Number(item.val);
              asd.time = item.ts;
              this.arr.push(asd);
            });
            this.arr.sort(function (a, b) {
              return new Date(a.time) > new Date(b.time) ? 1 : -1;
            });
            this.arr.forEach((item) => {
              this.arr2.push(item.time);
              this.arr3.push(item.value);
            });
            this.chartData.data = [
              {
                name: this.$t("alarm.alarmNum"),
                value: this.arr3,
              },
            ];
            this.chartData.category = this.arr2;
          }
          this.chartData.isLoading = false;
        })
        .catch((err) => {
          this.chartData.isLoading = false;
          this.emptyTextAlarmWarningStatus = true;
        });
    },
    // 故障折线图
    PlantsWarningAndFaultCount1() {
      this.chartData1.isLoading = true;
      this.arr4 = [];
      this.arr5 = [];
      this.arr6 = [];
      let param = {
        lev: 2,
        flag: 0,
      };
      this.$request
        .getMicroserDess("/alm/api/auth/web/warningTrend", param)
        .then((res) => {
          if (res.code === 0 && Array.isArray(res.data)) {
            res.data.forEach((item) => {
              let asd = {};
              asd.value = Number(item.val);
              asd.time = item.ts;
              this.arr4.push(asd);
            });
            this.arr4.sort(function (a, b) {
              return new Date(a.time) > new Date(b.time) ? 1 : -1;
            });
            this.arr4.forEach((item) => {
              this.arr5.push(item.time);
              this.arr6.push(item.value);
            });
            this.chartData1.data = [
              {
                name: this.$t("alarm.faultNum"),
                value: this.arr6,
              },
            ];
            this.chartData1.category = this.arr5;
          }
          this.chartData1.isLoading = false;
        })
        .catch((err) => {
          this.chartData1.isLoading = false;
          this.emptyTextAlarmFaultStatus = true;
        });
    },
    getUseractivity() {
      this.accountStatus.isLoading = true;
      this.$request
        .get("webQueryDeviceUsrViewEs")
        .then((res) => {
          if (res.err === 0) {
            this.totalUsr = res.dat.totol;
            let chartData = this.accountStatus.chartData || [];
            chartData.forEach((item) => {
              let active = res.dat[item.field][0].active - 0 || 0,
                inactive = res.dat[item.field][0].silence - 0 || 0;
              item.detail.push(
                {
                  name: i18n.t("statistic.active"),
                  value: active,
                  itemStyle: {
                    color: item.activeColor,
                  },
                },
                {
                  name: i18n.t("statistic.inactive"),
                  value: inactive,
                  itemStyle: {
                    color: "#ccc",
                  },
                }
              );
              item.summary.value = active + inactive;
            });
          }
          this.accountStatus.isLoading = false;
        })
        .catch((err) => {
          this.accountStatus.isLoading = false;
          this.emptyTextUserStatus = true;
        });
    },
    //用户活跃率
    getQueryDataIs() {
      this.chartData5.data = [
        {
          name: "参数1",
          value: [
            //
            "1.40", //0
            "1.50", //1
            "1.60", //2
          ],
        },
      ];
      this.chartData5.category = [
        //
        "图例A",
        "图例B",
        "图例C",
        "图例D",
      ];
    },
    // 获取设备分布数据（环形图）
    getQueryDeviceRegionViewEs() {
      this.deviceDistributionStatus.isLoading = true;
      let param = {
        i18n: this.$lang.currentLang,
        devtype: 2304,
      };
      this.$request
        .get("webQueryDeviceRegionViewEs", param)
        .then((res) => {
          let data = [];
          let numAll = 0;
          if (res.err == 0) {
            res.dat.forEach((item, index) => {
              numAll += Number(item.num);
              this.deviceDistributionStatus.dic.forEach((item1, index1) => {
                if (index == index1) {
                  data.push({
                    name: item.country,
                    value: item.num,
                    itemStyle: {
                      color: item1.color,
                    },
                  });
                  return;
                }
              });
            });
            this.deviceDistributionStatus.total.value = numAll;
            this.deviceDistributionStatus.chartData = data;
          } else {
            this.deviceDistributionStatus.chartData.push({
              itemStyle: { color: "rgb(148,163,179)" },
              name: this.$t("statistic.totalRegion"),
              value: 0,
            });
          }
          this.deviceDistributionStatus.isLoading = false;
        })
        .catch((err) => {
          this.deviceDistributionStatus.isLoading = false;
          this.emptyTextDistribution = true;
        });
    },
    // 获取设备状态
    queryDeviceStatus() {
      if (this.$store.state.user.dealerVcode == "08") {
        this.deviceDataloggerStatus.isLoading = true;
      } else {
        this.deviceStatus.isLoading = true;
      }
      // let action
      // if (this.$store.state.user.dealerVcode=='08') {
      //   action="webQueryCollectorStatusViewEs"
      // }else{
      //   action="webQueryDeviceStatusViewEs"
      // }
      this.$request
        .get("webQueryDeviceStatusViewEs", { devtype: 2304 })
        .then((res) => {
          let data = [];
          if (res.err === 0) {
            if (this.$store.state.user.dealerVcode == "08") {
              for (let key in this.deviceDataloggerStatus.dic) {
                let info = this.deviceDataloggerStatus.dic[key],
                  value = res.dat[key] ? res.dat[key] - 0 : 0;
                // 存储数据
                info.value = value;
                data.push({
                  name: info.name,
                  value,
                  itemStyle: {
                    color: info.color,
                  },
                });
              }
              this.deviceDataloggerStatus.total.value = res.dat.total;
            } else {
              for (let key in this.deviceStatus.dic) {
                let info = this.deviceStatus.dic[key],
                  value = res.dat[key] ? res.dat[key] - 0 : 0;
                // 存储数据
                info.value = value;
                data.push({
                  name: info.name,
                  value,
                  itemStyle: {
                    color: info.color,
                  },
                });
              }
              this.deviceStatus.total.value = res.dat.total;
            }
          } else {
            data = [
              {
                name: i18n.t("statistic.allDevice"),
                value: 0,
                itemStyle: {
                  color: "rgb(148,163,179)",
                },
              },
            ];
            if (this.$store.state.user.dealerVcode == "08") {
              this.deviceDataloggerStatus.total.value = 0;
            } else {
              this.deviceStatus.total.value = 0;
            }
          }
          if (this.$store.state.user.dealerVcode == "08") {
            this.deviceDataloggerStatus.chartData = data;
            this.deviceDataloggerStatus.isLoading = false;
          } else {
            this.deviceStatus.chartData = data;
            this.deviceStatus.isLoading = false;
          }
          console.log(
            this.deviceDataloggerStatus.chartData,
            "this.deviceDataloggerStatus.chartData"
          );
          console.log(
            this.deviceStatus.chartData,
            "this.deviceStatus.chartData"
          );
        })
        .catch(() => {
          this.emptyTextDeviceStatus = true;
          if (this.$store.state.user.dealerVcode == "08") {
            this.deviceDataloggerStatus.isLoading = false;
          } else {
            this.deviceStatus.isLoading = false;
          }
        });
    },
    // 获取告警事件总数
    queryAlarmStatus() {
      this.alarmStatus.isLoading = true;
      this.$request
        .getMicroserDess("/alm/api/auth/web/warningStatusCount")
        .then((res) => {
          let data = [];
          if (res.code === 0) {
            for (let key in this.alarmStatus.dic) {
              let info = this.alarmStatus.dic[key],
                value = res.data[key] ? res.data[key] - 0 : 0;
              // 存储数据
              info.value = value;
              data.push({
                name: info.name,
                value,
                itemStyle: {
                  color: info.color,
                },
              });
            }
            this.alarmStatus.total.value = res.data.Ignored;
            this.alarmTIME = res.data.UpdateTime ? this.$filter.formatDate(new Date(res.data.UpdateTime), "yyyy-MM-dd hh:mm:ss") : ""
          } else {
            data = [
              {
                // this.$t
                name: i18n.t("alarm.allAlarm"),
                value: 0,
                itemStyle: {
                  color: "rgb(148,163,179)",
                },
              },
            ];
            this.alarmStatus.total.value = 0;
          }
          this.alarmStatus.chartData = data;
          this.alarmStatus.isLoading = false;
        })
        .catch(() => {
          this.emptyTextAlarmStatus = true;
          this.alarmStatus.isLoading = false;
        });
    },
  },
};
</script>
<style lang="less" scoped>
.deviceOverview {
  // loading遮罩层
  /deep/.el-loading-mask {
    background-color: #222d35;
  }

  // loading花形
  /deep/.el-loading-spinner i {
    color: @primaryTextColor;
  }

  // loading动画大小
  /deep/.el-loading-spinner {
    font-size: 30px;
    font-weight: bold;
  }

  display: flex;
  flex-direction: column;
  width: 100%;
  height: 2000px;
  padding: 20px;
  .emptyTextRelative {
    height: 100%;
    width: 100%;
    position: relative;
  }
  .emptyTextAbsolute {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    margin: auto;
  }
  .deviceOverviewLeft {
    height: 100%;
    width: 100%;
    display: flex;
    justify-content: space-between;

    .deviceDiagram {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      width: 100%;
      margin-right: 15px;

      .deviceStatus {
        position: relative;
        min-width: 400px;
        height: 100%;
        background-color: rgb(34, 45, 53, 0.5);
        margin-bottom: 15px;

        .deviceStatusContent {
          // position: absolute;
          // top: 15px;
          // left: 38%;
          display: flex;
          justify-content: center;
          align-items: center;

          .deviceStatusLeft {
            height: 219px;
            width: 219px;
          }

          .deviceStatusRight {
            display: flex;
            flex-direction: column;
            padding: 0 0 0 40px;

            div {
              min-width: 150px;
              color: #ebebeb;
              margin: 8px 0;

              .status-icon {
                width: 10px;
                height: 10px;
                margin-right: 8px;
              }

              .item-name {
                margin-right: 8px;
              }
            }
          }
        }

        .eb-chart-topleft {
          color: #f3fafe;
          font-size: 16px;

          span {
            display: inline-block;
            margin-left: 24px;
            margin-top: 17px;
          }
        }
      }

      .deviceDistribution {
        position: relative;
        height: 100%;
        background-color: rgb(34, 45, 53, 0.5);

        .eb-chart-topleft {
          color: #f3fafe;
          font-size: 16px;

          span {
            display: inline-block;
            margin-left: 24px;
            margin-top: 17px;
          }
        }

        .deviceDistributionContent {
          // position: absolute;
          // top: 15px;
          // left: 38%;
          margin-left: 150px;
          display: flex;
          justify-content: center;
          align-items: center;

          .deviceDistributionLeft {
            height: 219px;
            width: 219px;
          }

          .deviceDistributionRight {
            column-count: 2;
            min-width: 175;
            padding-left: 40px;

            div {
              min-width: 150px;
              color: #ebebeb;
              padding: 8px 0;

              .status-icon {
                width: 10px;
                height: 10px;
                margin-right: 8px;
              }

              .item-name {
                margin-right: 8px;
              }
            }
          }
        }
      }

      .alarmStatus1 {
        margin-top: 15px;
        position: relative;
        min-width: 400px;
        height: 100%;
        background-color: rgb(34, 45, 53, 0.5);

        .alarmStatusContent {
          position: absolute;
          top: 25px;
          left: 38%;
          display: flex;
          justify-content: center;
          align-items: center;

          .alarmStatusLeft {
            height: 219px;
            width: 219px;
          }

          .alarmStatusRight {
            display: flex;
            flex-direction: column;
            padding: 0 0 0 40px;

            div {
              color: #ebebeb;
              margin: 8px 0;

              .status-icon {
                width: 10px;
                height: 10px;
                margin-right: 8px;
              }

              .item-name {
                margin-right: 8px;
              }
            }
          }
        }

        .eb-chart-topleft {
          color: #f3fafe;
          font-size: 16px;

          span {
            display: inline-block;
            margin-left: 24px;
            margin-top: 17px;
          }
        }
      }
    }

    .userActivity {
      width: 927px;
      height: 100%;
      background-color: rgb(34, 45, 53, 0.5);

      .totalnum {
        color: #f3fafe;
        font-size: 16px;
        margin-left: 24px;
        margin-right: 24px;
        margin-top: 17px;
        display: flex;
        justify-content: space-between;
      }

      .chart-account {
        margin-top: 80px;
      }
    }

    .userActivity1 {
      width: 927px;
      height: 100%;
      background-color: rgb(34, 45, 53, 0.5);

      .totalnum {
        color: #f3fafe;
        font-size: 16px;
        margin-left: 24px;
        margin-right: 24px;
        margin-top: 17px;
        display: flex;
        justify-content: space-between;
      }

      .chart-account {
        margin-top: 230px;
      }
    }
  }

  .deviceOverviewRight {
    height: 291px;
    width: 100%;
    display: flex;
    margin-top: 15px;

    .alarmStatus {
      background-color: rgb(34, 45, 53, 0.5);
      width: 100%;

      .alarmStatusContent {
        display: flex;
        justify-content: center;
        align-items: center;

        .alarmStatusLeft {
          height: 219px;
          width: 219px;
        }

        .alarmStatusRight {
          min-width: 175px;
          display: flex;
          flex-direction: column;
          padding: 0 0 0 40px;

          div {
            color: #ebebeb;
            margin: 8px 0;

            .status-icon {
              width: 10px;
              height: 10px;
              margin-right: 8px;
            }

            .item-name {
              margin-right: 8px;
            }
          }
        }
      }

      .eb-chart-topleft {
        color: #f3fafe;
        font-size: 16px;

        span {
          display: inline-block;
          margin-left: 24px;
          margin-top: 17px;
        }
      }

      /* 更新时间：展示在卡片头部右侧 */
      .alarm-update-time {
        // float: right;
        margin-top: 17px;
        margin-right: 20px;
        color: #f3fafe;
        font-size: 16px;
      }
    }

    .warningStatus {
      background-color: rgb(34, 45, 53, 0.5);
      width: 100%;
      margin: 0 15px;
      height: 100%;

      .eb-chart-topleft {
        color: #f3fafe;
        font-size: 16px;

        span {
          display: inline-block;
          margin-left: 24px;
          margin-top: 17px;
        }
      }

      .eb-chart-panel {
        height: 100%;

        .line {
          height: 90%;
        }
      }
    }

    .faultStatus {
      background-color: rgb(34, 45, 53, 0.5);
      width: 100%;

      .eb-chart-topleft {
        color: #f3fafe;
        font-size: 16px;

        span {
          display: inline-block;
          margin-left: 24px;
          margin-top: 17px;
        }
      }

      .eb-chart-panel {
        height: 100%;

        .line {
          height: 90%;
        }
      }
    }
  }
}
</style>
<style lang="less">
// #分页下拉框#
.select-page {
  background-color: rgb(34, 45, 53);
  box-shadow: 0px 8px 21px rgba(11, 12, 13, 0.3);
  border-radius: 12px;
  border: none;
  padding: 8px 0px;

  .el-select-dropdown__list {
    padding: 0px;
    background-color: rgb(34, 45, 53);
  }

  .el-select-dropdown__item {
    padding: 0px 16px;
    font-size: 14px;
    height: 32px;
    line-height: 32px;
    color: rgba(255, 255, 255, 1);
    min-width: 110px;
  }

  .el-select-dropdown__item.hover {
    padding: 0px 16px;
    background-color: transparent;
    font-weight: normal;
  }

  .el-select-dropdown__item.selected {
    padding: 0px 16px;
    background-color: transparent;
    font-weight: normal;
    color: rgba(255, 255, 255, 1);
  }

  .el-select-dropdown__item:hover {
    padding: 0px 16px;
    background: @primaryColorTransparency30;
    color: rgba(255, 255, 255, 1);
  }

  .el-select-dropdown__item.selected .select-label {
    padding: 0px;
  }

  // 对号
  .el-select-dropdown__item.selected:before,
  .el-select-dropdown__item.selected .select-label:before,
  .el-select-dropdown__item.selected.choose-num:before {
    content: "";
    display: inline-block;
    height: 16px;
    width: 16px;
    background: url(../../../assets/img/general/Icon_Duihao.png);
    background-repeat: no-repeat;
    background-size: 100%;
    background-position: center;
    position: absolute;
    top: 8px;
    right: 16px;
  }

  &[x-placement^="top"] .popper__arrow {
    display: none;
  }
}

// #下拉选框#
.select-search-recharge {
  background-color: rgb(34, 45, 53);
  box-shadow: 0px 8px 21px rgba(11, 12, 13, 0.3);
  border-radius: 4px;
  border: none;
  padding: 8px 0px;

  .el-select-dropdown__list {
    padding: 0px;
  }

  .el-select-dropdown__item {
    padding: 0px 16px;
    font-size: 14px;
    height: 32px;
    line-height: 32px;
    color: rgba(255, 255, 255, 1);
  }

  .el-select-dropdown__item.hover {
    padding: 0px 16px;
    background-color: transparent;
    font-weight: normal;
  }

  .el-select-dropdown__item.selected {
    padding: 0px 16px;
    background-color: transparent;
    font-weight: normal;
    color: rgba(255, 255, 255, 1);
  }

  .el-select-dropdown__item:hover {
    padding: 0px 16px;
    background: @primaryColorTransparency30;
    color: rgba(255, 255, 255, 1);
  }

  .el-select-dropdown__item.selected .select-label {
    padding: 0px;
  }

  // 对号
  .el-select-dropdown__item.selected:before,
  .el-select-dropdown__item.selected .select-label:before,
  .el-select-dropdown__item.selected.choose-num:before {
    content: "";
    display: inline-block;
    height: 16px;
    width: 16px;
    background: url(../../../assets/img/general/Icon_Duihao.png);
    background-repeat: no-repeat;
    background-size: 100%;
    background-position: center;
    position: absolute;
    top: 8px;
    right: 0px;
  }

  // 滚动条
  ::-webkit-scrollbar {
    // width: 0px;
    // height: 0px;
    background-color: transparent;
  }
}

.select-search-project {
  .el-select-dropdown__list {
    padding: 0 16px;
  }

  .el-select-dropdown__item {
    height: 40px;
    line-height: 40px;
    box-shadow: 0px 0.5px rgba(198, 209, 221, 0.2);
  }
}

.selectClearNew {
  // 下拉选中清除按钮
  .el-icon-circle-close:before {
    content: "";
    display: inline-block;
    height: 16px;
    width: 16px;
    background: url(../../../assets/img/general/Icon_SelectClear.png);
    background-repeat: no-repeat;
    background-size: 100%;
    background-position: center;
    // position: absolute;
    // top: 8px;
    // right: 16px;
  }
}

.deviceName .el-tooltip {
  color: @primaryTextColor;
}
</style>